import React from 'react'
import '../css/inspiration.css'

function inspiration() {
  return (
    <div>
    <div className='inspiration-mian'>
    <h1> The Inspiration</h1>

    <div className='ourinspiration'>
    <div className='ourinspiration-img-box'>
    <div className='left-side'>
    <div className='innerbox'>
    <div className='imgbox-ourter'>
    <img src='../img/Lachman A. Bhatia.webp'/>
    </div>
    {/*<div className='content-box'>
    <h4>Lachman A. Bhatia</h4>
    <p>April 1, 1938 - July 27, 2019</p>
  </div>*/}
    <div className='content-box'>
    <h4>Lachman A. Bhatia</h4>
    <p>April 1, 1938 - July 27, 2019</p>
    </div>
    </div>
    </div>
    <div className='right-side'>

    <div className='innerbox'>
    <div className='imgbox-ourter'>

    <img src='../img/Kanhiya Thahryamal.webp'/>
    </div>
    <div className='content-box'>
    <h4>Kanhiya Thahryamal</h4>
    <p>December 20,1964 - July 1, 2006</p>
    </div>
    </div>
    </div>
 
    </div>
    <p className='bottomline'>We salute the man who put in his best to give the city another good school. Sanskar School is the result of Mr. Kanni Thahryamal’s dream, initiative and untiring efforts.</p>
    </div>
      
    </div>
    </div>
  )
}

export default inspiration
